import { utilService } from "../../../services/utilService";
import { apiServiceConstants } from "../../../constants/apiService.constants";
import { apiService } from "../../../services/apiService";
import {
  NurseCalculatorInterface,
  NurseCalculatorModel,
  NurseCalculatorReq,
  NurseCalculatorUrl,
  Result,
} from "./NurseCalculator.model";

const getNurseCalculatorUrl = async (
  params: NurseCalculatorReq
): Promise<NurseCalculatorInterface> => {
  const respApiResult = await apiService
    .apiCall(
      `sboard/unit/nurse-calculation/?reg_code=${utilService.getNetwork()}`,
      params,
      apiServiceConstants.GET,
      utilService.getDeviceType()
    )
    .then((res) => {
      const nurseCalculatorResp = res as NurseCalculatorModel;
      var resultData: any;
      if (nurseCalculatorResp.result) {
        resultData = mapNurseCalculatorResult(nurseCalculatorResp.result);
      }
      const result: NurseCalculatorInterface = {
        isSuccess: true,
        status: nurseCalculatorResp.status,
        message: nurseCalculatorResp.message,
        result: resultData,
      };
      return result;
    })
    .catch((err) => {
      const result: NurseCalculatorInterface = {
        isSuccess: false,
        message: err.message,
        status: err.status,
      };
      return result;
    });

  return respApiResult;
};

const mapNurseCalculatorResult = (payload: Array<Result>) => {
  let resultListArray = payload.map((object: Result) => {
    return {
      count: object.count,
      next: object.next,
      previous: object.previous,
      data: mapNurseCalculatorData(object.data),
    };
  });
  return resultListArray;
};

const mapNurseCalculatorData = (payload: Array<NurseCalculatorUrl>) => {
  let urlListArray = payload.map((object: NurseCalculatorUrl) => {
    return {
      url: object.url,
    };
  });
  return urlListArray;
};

const handleErrorResponse = () => {};

export const nurseCalculatorService = {
  getNurseCalculatorUrl,
  handleErrorResponse,
};
